import { useI18n } from 'next-localization';

import { GenericModal } from '@/components/modals';

import { TIME_RELEASED_MODAL } from '../constants';

interface Props {
  onModalAccept: () => void;
  onModalDecline: () => void;
  skipDeclineHandlerOnDismiss?: boolean;
}

export const TimeReleasedModal = ({
  onModalAccept,
  onModalDecline,
  skipDeclineHandlerOnDismiss,
}: Props): JSX.Element => {
  const { t } = useI18n();
  return (
    <GenericModal
      name={TIME_RELEASED_MODAL}
      label=""
      acceptButtonText={t('OAS.Booking.Appointment.TimeReleasedModal.BackToTimes')}
      declineButtonText={t('OAS.Booking.Appointment.TimeReleasedModal.BackToProfile')}
      handleModalAccept={onModalAccept}
      handleModalDecline={onModalDecline}
      skipDeclineHandlerOnDismiss={skipDeclineHandlerOnDismiss}
    >
      <h3 className="mb-4">{t('OAS.Booking.Appointment.TimeReleasedModal.Title')}</h3>
      <p>{t('OAS.Booking.Appointment.TimeReleasedModal.Text')}</p>
    </GenericModal>
  );
};
